import React from 'react'
import {
  Card,
  CardContent,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core'

import { CustomFieldValue, FreightOrder } from 'src/api/models'

interface FreightOrderCompactProps {
  obj: FreightOrder
}

export const FreightOrderCompact = (props: FreightOrderCompactProps) => {
  const { obj } = props
  return (
    <Paper variant="outlined">
      <Card>
        <CardContent>
          <Grid container>
            <Grid item>
              <Typography>
                {obj.client?.name} Order #{ obj.number }
              </Typography>
            </Grid>
            {!!obj.customFields?.length && (
              <Grid item xs={12}>
                {obj.customFields?.map((cf: CustomFieldValue) => (
                  <Typography>
                    { cf.label }: { cf.value }
                  </Typography>
                ))}
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Paper>
  )
}
